_getUsernameAvailability